import {
  createSlice,
  PayloadAction,
  ActionReducerMapBuilder,
} from '@reduxjs/toolkit'
import { initialState } from '../initialState/waitingRoomWebsocket'
import { GameRoomStatus } from '../types/room'

const waitingRoomWebsocketSlice = createSlice({
  name: 'waitingRoomWebsocket',
  initialState,
  reducers: {
    setConnectionStatus(state, action: PayloadAction<boolean>) {
      state.isConnected = action.payload
    },
    setWebSocketError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },
    setWaitingRoomStatus(state, action: PayloadAction<GameRoomStatus>) {
      state.waitingRoomStatus = action.payload

      if (action.payload === GameRoomStatus.COMPLETED) {
        state.gameEnded = true
      }
    },
    setGameEndedStatus(state, action: PayloadAction<boolean>) {
      state.gameEnded = action.payload
    },
    setCharterTeamReady(
      state,
      action: PayloadAction<{
        teamId: number
        ready: boolean
        allTeamsReady?: boolean
      }>
    ) {
      state.charterTeamReadiness[action.payload.teamId] = action.payload.ready
      if (action.payload.allTeamsReady !== undefined) {
        state.charterAllTeamsReady = action.payload.allTeamsReady
      }
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<typeof initialState>) => {
    builder
      .addCase('websocket/connectWaitingRoom/fulfilled', (state) => {
        state.isConnected = true
        state.error = null
      })
      .addCase(
        'websocket/connectWaitingRoom/rejected',
        (state, action: any) => {
          state.isConnected = false
          state.error =
            action.error?.message || 'Waiting Room WebSocket connection failed'
        }
      )
  },
})

export const {
  setConnectionStatus,
  setWebSocketError,
  setWaitingRoomStatus,
  setGameEndedStatus,
  setCharterTeamReady,
} = waitingRoomWebsocketSlice.actions
export default waitingRoomWebsocketSlice.reducer
